import React from 'react'
import {
    StyledBundleImage,
    StyledEntitledContainer,
    StyledEntitledText,
    StyledOpportunityContainer,
    StyledOpportunityText,
    StyledSubscribeButton,
    StyledTextEmphasis,
    StyledWestMark,
} from '../../cards/TWStaticSubscribeCard/TWStaticSubscribeCard.styled'
import { TheWestMark } from '../../logos/TheWestMark/TheWestMark'
import { EntitledToView } from '../../user-registration/entitlements/EntitledToView'
import { colors } from '../../__styling/settings/colors'

export const EntitledView = () => {
    return (
        <StyledEntitledContainer>
            <StyledWestMark>
                <TheWestMark fill={colors.white} height={30} width={38} />
            </StyledWestMark>
            <StyledEntitledText>
                Enjoy all <StyledTextEmphasis>exclusive</StyledTextEmphasis>{' '}
                content.
            </StyledEntitledText>
        </StyledEntitledContainer>
    )
}
export const OpportunityView = () => {
    const subscribeUrl = 'https://subscriber.thewest.com.au'
    const subscribeUtm =
        '/?utm_source=Thewest&utm_medium=Subscriber-tile&utm_campaign=gerardross&utm_term=&utm_content=Subscribe-now'
    const bundle = require('./images/bundle-everyday-digital-web.png')
    const bundle2x = require('./images/bundle-everyday-digital-web.png')
    const bundleSrcSet = `${bundle} 1x, ${bundle2x} 2x`

    return (
        <StyledOpportunityContainer>
            <StyledOpportunityText>
                Subscribe and enjoy exclusive content
            </StyledOpportunityText>
            <StyledSubscribeButton to={subscribeUrl + subscribeUtm}>
                Subscribe Now
            </StyledSubscribeButton>

            <StyledBundleImage>
                <img
                    src={bundle}
                    srcSet={bundleSrcSet}
                    alt=""
                    role="presentation"
                />
            </StyledBundleImage>
        </StyledOpportunityContainer>
    )
}

export const TWStaticSubscribeCard = () => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView />
            }}
            notEntitled={() => {
                return <OpportunityView />
            }}
        />
    )
}
